export default "__VITE_ASSET__D2Gr4vjW__"